import React from "react";

export const FamilyDisabledPage = () => (
  <main className="FamilyDisabledPage">
    <div className="FamilyDisabledPagePanel">
      <p>
        Configurez votre monument funéraire personnalisé sur{" "}
        <a href="https://www.gpggranit.com/" target="_blank" rel="noopener noreferrer">
          gpggranit.com
        </a>
      </p>
      <a
        className="FamilyDisabledPageAction"
        href="https://www.gpggranit.com/"
        target="_parent"
        rel="noopener noreferrer"
      >
        Personnaliser un monument
      </a>
    </div>
  </main>
);
